//jqueryFree
export default function () {
	if (typeof window.smartform === 'object') {
		let smartformKey = document.getElementById('smartformLoad').getAttribute('data-smartform-key');

		window.smartform.beforeInit = function () {
			window.smartform.setClientId(smartformKey);
		};

		const addressInput = document.getElementById('address');

		const checkVisibilityResetBtn = () => {
			resetSmartformBtn.classList.toggle('hidden', addressInput.value === '');
		};

		const checkSubmitAllowed = () => {
			return (
				(addressInput.value.length > 0 && document.getElementById('addressHidden').value.length > 0) ||
				addressInput.value.length === 0
			);
		};

		const resetSelectedAddress = () => {
			document.getElementById('addressHidden').value = '';
			document.getElementById('locLa').value = '';
			document.getElementById('locLo').value = '';
		};

		checkVisibilityResetBtn();

		window.smartform.afterInit = function () {
			let previousAddressValue = document.getElementById('address').value;
			let instance = window.smartform.getInstance();
			instance.addressControl.addValidationCallback(function (result) {
				if (result.result.type === window.smartform.AddressValidationResultType.HIT) {
					//save to hidden inputs
					document.getElementById('addressHidden').value = document.getElementById('address').value;
					document.getElementById('locLa').value = result.result.addressArray[0].COORD_WGS84_LATITUDE;
					document.getElementById('locLo').value = result.result.addressArray[0].COORD_WGS84_LONGITUDE;
					if (previousAddressValue !== document.getElementById('address').value) {
						document.getElementById('addressHidden').form.submit(); // auto submit after adress is selected
					}
				}
			});
		};

		document.getElementById('resetSmartformBtn').addEventListener('click', async () => {
			document.getElementById('address').value = '';
			await new Promise((resolve) => setTimeout(resolve, 10));
			checkVisibilityResetBtn();
			resetSelectedAddress();
			return false;
		});

		document.getElementById('address').addEventListener('keyup', () => {
			setTimeout(checkVisibilityResetBtn, 0);
			setTimeout(resetSelectedAddress, 0);
		});

		const modalElement = document.getElementById('errorSearchPopup');

		const form = document.getElementById('searchForm');

		// workaround for form method GET - we need to reset method to stop submit first and then return back and resubmit
		const originalAction = form.action;
		form.setAttribute('action', 'javascript:void(0);');

		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const modalInstance = window.Modal.getOrCreateInstance(modalElement);
			if (!checkSubmitAllowed()) {
				modalInstance.show();
			} else {
				form.setAttribute('action', originalAction);
				setTimeout(function () {
					form.submit();
				}, 0);
			}
		});
	}
}
